import { YStack, Text } from 'tamagui'
import type { QuoteSlide as QuoteSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, getAccentGlow } from './shared'

export function QuoteSlide({ slide }: { slide: QuoteSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner alignItems="center" style={{ padding: 'clamp(40px, 8vw, 100px)' }}>
        <Text
          fontFamily="$heading"
          color={accentColor}
          style={{ fontSize: 'clamp(48px, 8vw, 100px)', lineHeight: '0.8em', textShadow: getAccentGlow(slide.accent) }}
        >
          {'"'}
        </Text>
        <Text
          fontFamily="$body"
          fontWeight="300"
          fontStyle="italic"
          color="$textPrimary"
          textAlign="center"
          style={{ fontSize: 'clamp(16px, 2.5vw, 32px)', lineHeight: '1.5em', maxWidth: '800px' }}
        >
          {slide.quote}
        </Text>
        <Text
          fontFamily="$mono"
          color="$textMuted"
          marginTop="$4"
          style={{ fontSize: 'clamp(11px, 1.2vw, 16px)' }}
        >
          {'— '}{slide.attribution}
        </Text>
      </SlideInner>
    </SlideContainer>
  )
}
